import { fitCanvasTimePage } from "@/lib/canvas-time-page-actions";
import { buildCanvasTimePages } from "@/components/canvas/canvas-time-pages";
import { rememberCanvasTimePageMembership } from "@/lib/canvas-time-page-membership";
import { useCanvasStore } from "@/stores/canvas-store";
import { usePresentationStore } from "@/stores/presentation-store";
import { useProjectStore } from "@/stores/project-store";

type CanvasState = ReturnType<typeof useCanvasStore.getState>;

const FIT_START_DELAY_MS = 50;

let fitReturnSeq = 0;

function currentStateFor(
  seq: number,
  spaceId: string | null,
): CanvasState | null {
  if (seq !== fitReturnSeq) return null;
  const current = useCanvasStore.getState();
  if (usePresentationStore.getState().presentation) return null;
  const currentSpaceId = useProjectStore.getState().currentSpace?.id ?? null;
  if (spaceId && currentSpaceId && currentSpaceId !== spaceId) return null;
  return current;
}

function runFinalFit(seq: number, spaceId: string | null) {
  const current = currentStateFor(seq, spaceId);
  if (!current) return;
  fitCanvasTimePage();
}

export function fitTidiedFrames(spaceId: string | null = null) {
  const nodes = useCanvasStore.getState().nodes;
  rememberCanvasTimePageMembership(
    nodes,
    spaceId,
    buildCanvasTimePages(nodes, spaceId),
  );
  fitReturnSeq += 1;
  const seq = fitReturnSeq;
  setTimeout(() => {
    runFinalFit(seq, spaceId);
  }, FIT_START_DELAY_MS);
}
